import React, { useState, useEffect } from "react";
import FloatingMenu from "../components/FloatingMenu";

const Donasi = () => {
    const [datas, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch(
                "https://cms.okoce.net/api/admin/donations"
            );
            if (!response.ok) {
                throw new Error("Gagal mengambil data donasi");
            }
            const data = await response.json();
            const donasiData = data.data;
            setData(donasiData);
        } catch (error) {
            setData([]);
        }
    };

    
    const removeFigcaptionFromDescription = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const figcaptions = doc.querySelectorAll('figcaption');
        figcaptions.forEach(figcaption => figcaption.remove());
        return doc.body.innerHTML; // Kembalikan HTML tanpa <figcaption>
    };

    
    return (
        <>
            <div className="bg-gray-100 w-full grid justify-items-center items-center">
                <div className="w-full my-36 max-w-6xl rounded-lg p-6 text-surface">
                    <h2 className="mb-5 text-4xl font-extrabold text-center pt-10">Qris Donasi OK OCE INDONESIA</h2>
                    <p className="text-center text-xl px-12">
                        OK OCE adalah Gerakan Sosial Penciptaan Lapangan Kerja Berbasis Wirausaha. Kami membuka <br />bagi siapapun yang memiliki kesamaan visi, nilai dan perjuangan untuk mendukung gerakan ini dengan berdonasi melalui : <br /><br />
                        <span className="font-bold text-2xl">Bank Syariah Indonesia (ex-BSM) </span> <br />
                        an. OK OCE INDONESIA No. Rekening 7148254367 <br />
                        Scan QRIS melalui Aplikasi Payment dan Mobile Banking Melalui :
                    </p>
                    {/* Displaying cards in a 3-column grid layout with equal height */}
                    <div className="flex flex-wrap justify-center">
                        {datas.map((data, index) => {
                            const cleanedDescription = removeFigcaptionFromDescription(data.description);
                            const imgRegex = /<a[^>]+href="([^"]+)"[^>]*><img[^>]*><\/a>/;
                            const match = data.description.match(imgRegex);
                            const imgSrc = match ? match[1] : null;

                            return (
                                <div
                                    key={index}
                                    className="flex flex-col items-center justify-center p-5 w-full md:w-1/2 max-md:w-full"
                                >
                                    <div className="bg-white p-6 shadow-md rounded-lg text-black w-full flex flex-col justify-between h-full">
                                        <div className="flex-grow">
                                            <h3 className="text-3xl font-semibold mb-4 text-center min-h-[60px]">{data.title}</h3>
                                            {imgSrc && (
                                                <div className="mb-4 text-center">
                                                    <img src={imgSrc} alt={`QR for ${data.title}`} className="w-32 h-32 mx-auto" />
                                                </div>
                                            )}
                                            <div className="text-lg leading-relaxed text-justify min-h-[200px]" dangerouslySetInnerHTML={{ __html: cleanedDescription }}>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <FloatingMenu />
        </>
    );
};

export default Donasi;
